import React, { useEffect, useRef } from "react";
import { rotateAnimation } from "../../../../../images";

const OrbitIcons = ({ icons = [], radius = 120 }) => {
  const containerRef = useRef(null);
  const animationRef = useRef(null);

  useEffect(() => {
    let start = null;
    const duration = 60000;
    let frame;

    const animate = (timestamp) => {
      if (!start) start = timestamp;
      const elapsed = timestamp - start;
      const percent = (elapsed % duration) / duration;
      const angleOffset = percent * 2 * Math.PI;

      const container = containerRef.current;
      if (!container) return;

      const width = container.clientWidth;
      const height = container.clientHeight;
      const centerX = width / 2;
      const centerY = height / 2;
      const orbitRadius = Math.min(width, height) / 2.4; // 🔹 auto scale orbit

      icons.forEach((_, index) => {
        const iconElem = container.children[index];
        if (!iconElem) return;

        const angle = (2 * Math.PI / icons.length) * index + angleOffset;
        const x = centerX + orbitRadius * Math.cos(angle) - iconElem.clientWidth / 2;
        const y = centerY + orbitRadius * Math.sin(angle) - iconElem.clientHeight / 2;

        iconElem.style.transform = `translate(${x}px, ${y}px)`;
      });

      frame = requestAnimationFrame(animate);
      animationRef.current = frame;
    };

    frame = requestAnimationFrame(animate);
    animationRef.current = frame;
    return () => cancelAnimationFrame(frame);
  }, [icons]);

  return (
    <div
      style={{
        position: "relative",
        width: "100%",
        maxWidth: "500px",
        aspectRatio: "1/1",
        margin: "0 auto",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
      }}
    >
      {/* Orbit animation background */}
      <img
        src={rotateAnimation}
        alt="orbit-bg"
        className="orbit-img"
        style={{
          width: "100%",
          height: "100%",
          objectFit: "contain",
        }}
      />

      {/* Rotating icons */}
      <div
        ref={containerRef}
        style={{
          position: "absolute",
          top: 0,
          left: 0,
          width: "100%",
          height: "100%",
        }}
      >
        {icons.map((icon, idx) => (
          <div
            key={idx}
            style={{
              position: "absolute",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              filter: "drop-shadow(0px 0px 10px #ffffff)",
              transition: "transform 0.2s ease-out",
            }}
          >
            <img
              src={icon}
              alt={`icon-${idx}`}
              style={{
                width: "auto",
                height: "clamp(24px, 4vw, 40px)", // ✅ responsive icon size
                objectFit: "contain",
              }}
            />
          </div>
        ))}
      </div>
    </div>
  );
};

export default OrbitIcons;
